<template>
    <div id="features">
        <AppNavigation bgColor='rgb(255,128,57)' textColor='#fff'/>

        <!---------- FEATURES HERO ------>
        <div id="hero">

        </div>
        <!------------- How it works ---------->
        <div id="how_it_works">

        </div>
        <!---------- BUSINESS CASE------------->
        <div id="business-case" class="d-flex flex-wrap align-content-center justify-content-center">
        <div class="container-fluid">
          <div class="row align-content-center">
            <div class="col-4 side-image-left-container">
              <img class="side-image-left img-fluid p-0 m-0" src="../assets/images/features_side_image.jpg" alt="" >
            </div>
            <div class="col-12 hero-text justify-content-center align-items-center" >
              <div class="row">
                  <div class="padding d-flex align-content-center">
                      <div class="col-sm-12 col-md-11 col-lg-8 ml-auto ">
                        <h2 class="py-3">
                            Business Case
                        </h2>
                        <ul>
                            <li>
                                <i> <img src="../assets/images/list_icon.jpg" alt=""> </i>
                                Caravan secures grants to be disbursed in the form of loans or actual grants.
                            </li>
                            <li>
                                <i> <img src="../assets/images/list_icon.jpg" alt=""> </i>
                                Slum Dwellers (SlumD) identifies micro-entrepreneurs in need of relief support.
                            </li>
                            <li>
                                <i> <img src="../assets/images/list_icon.jpg" alt=""> </i>
                                SlumD assesses their needs and sign-up the qualified micro-entrepreneurs unto FISCOIN.
                            </li>
                            <li>
                                <i> <img src="../assets/images/list_icon.jpg" alt=""> </i>
                                Caravan team reviews the sign-up applicants, approves and issue digital 
                                vouchers to the qualified applicants in return for their service to provide
                                community related services.
                            </li>
                            <li>
                                <i> <img src="../assets/images/list_icon.jpg" alt=""> </i>
                                Issued digital vouchers can be redeemed at communinty stores or via mobile money
                            </li>
                        </ul>
                   </div>
              </div>
              </div>
            </div>
            <div class="col-3 side-image-right-container">
              <img  class="side-image-right img-fluid" src="../assets/images/circle_orange.png" alt="" >
            </div> 
          </div>
         </div>
        </div>
        <!---------- FOOTER ------------->
        <Footer /> 
    </div>
</template>
<script >
import AppNavigation from '../components/AppNavigation'
import Footer from '../components/Footer'

export default{
    components: {
        AppNavigation,
        Footer
    }
}
</script>

<style scoped>
    #hero{
        background-image: url('../assets/images/features_hero.jpg');
        width:100%;
        height:calc(100vh - 100px);
        overflow: hidden;
        /* background-attachment: fixed; */
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;    
        }
        #how_it_works{
        background-image: url('../assets/images/how_it_works.jpg');
        width:100%;
        height:100vh;
        overflow: hidden;
        /* background-attachment: fixed; */
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;    
        }
    #features{
        overflow:hidden ;
    }
   #business-case{
        position: relative;
    }
    .side-image-left-container{
        position:absolute;
        left:-50px;
        }
     .side-image-right-container{
        position:absolute;
        right:-18%;
        bottom: 0;
        }    
    .hero-text h2{
        color:black;
        font-weight: 700;
        font-size: 4em;
        }
    .padding{
      padding:150px 20px;
     
    }
    ul li{
        color:rgb(255,128,57);
        line-height: 2em ;
        list-style: none;
    }
    ul li i img{
        height:25px;
        padding-right:8px;
    }
</style>